export const AI_MODELS = [
  {
    id: 'claude-opus-4-7',
    name: 'Ultra',
    providerId: 'anthropic',
    modelId: 'us.anthropic.claude-opus-4-7',
    description: '가장 깊은 추론 · 발행 최종 검수',
    icon: '👑',
    bgColor: 'bg-purple-500/10',
    textColor: 'text-purple-500',
    maxTokens: 16384,
    isDefault: true,
  },
  {
    id: 'claude-sonnet-4-6',
    name: 'Pro',
    providerId: 'anthropic',
    modelId: 'us.anthropic.claude-sonnet-4-6',
    description: '균형 잡힌 응답 · 빠른 초안 작성',
    icon: '✨',
    bgColor: 'bg-purple-500/10',
    textColor: 'text-purple-500',
    maxTokens: 8192,
  },
];

export const DEFAULT_MODEL = AI_MODELS.find((m) => m.isDefault) || AI_MODELS[0];
export const getModelById = (id) => AI_MODELS.find((m) => m.id === id) || DEFAULT_MODEL;

export default AI_MODELS;
